import { Link } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'

export const meta = () => {
    const title = "JaseOwns - Gaming - Ultima Online";
    const description = "Ultima Online came out in September 1997, I remember bugging my dad about getting it while playing Diablo 1 on Battle.NET as people online were talking about this new game.";
    return [
    { title: title },
    { description: description},
    { name: "keywords", content: "ultima online,creator,videos,uo,ultima online,1997"},
    { property: "og:image", content: "https://jaseowns.com/images/uo-feels.jpg"},
    { property: "og:image:alt", content: "Ultima Online Wallpaper"},
    { property: "twitter:card", content: "summary"},
    { property: "twitter:creator", content: "@jaseowns"},
    { property: "twitter:site", content: "@jaseowns"},
    { property: "og:title", content: title},
    { property: "og:description", content: description},
]}

export default function Index() {
	return (
		<div className="container mx-auto text-black dark:text-white">
			<section id="gaming">
				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200"><Link to="/gaming" className="underline">Gaming</Link> - Ultima Online</h1>
                <div className="px-10">
                    <h3>Check out the growing UO community over at <a href="https://uoaddicts.com/" className='underline'>UOAddicts.com</a></h3>
                    <div className="my-6">
                        <img className="md:float-left md:w-1/2 md:mr-16" src="/images/uo-feels.jpg" alt="uo wallpaper" />
                        <div className="lg:px-4 my-2">
                            Ultima Online came out in September 1997, I remember bugging my dad about getting it while playing Diablo 1 on Battle.NET as people online were talking about this new game.  I got a gamer magazine with an article about UO in it and I was hooked before I even had a chance to play.  The idea of an open world where you can turn your character into anything by using the skills was mesmerizing. The fact you could adventure out to slay dragons, chop trees to make furniture, bows and arrows, mine for ore to make weapons and armor was overwhelmingly appealing - but even more so was the fact you steal from and kill other players.  The twelve year old me was an unstoppable a-hole!
                        </div>
                        <p className="my-8 text-center italic font-bold">
                            Did you know people stream Ultima Online still? Check out <Link to="/streamers" className="underline">UO Streamers</Link> to take a look.
                        </p>
                        <p className="my-8 text-center italic font-bold">
                            Check out the <Link to="/gaming/ultima-online/new-player-guides" className="underline">Ultima Online new player guides</Link> if you are interested in seeing how to get started with no help!
                        </p>
                        <div className="mx-8 lg:px-4 my-4">
                            UO is actually the game that got me my career I have today in web development.  It wasn't long after playing that I asked my dad for a book about HTML as I wanted to make a web page so I could post pictures of the players I killed and show them how they got "owned" - I would have loved to say this is where jaseowns.com was born, however it was a Geocities webpage at first.    
                        </div>
                        <h2 className="text-3xl px-10 my-6 text-cyan-900 dark:text-cyan-200">What server did you play?</h2>
                        <div className="mx-4 lg:px-4">
                            The main ones I played were: Napa Valley, Chesapeake, Baja, Pacific.
                        </div>
                        <div className="mx-8 lg:px-4 my-4">
                            Being a young kid and not understanding how the internet worked, when you logged in to Ultima via dial up - you choose a "shard" to play.  I didn't know the names related to location so I actually played on multiple servers.  I also didn't know for a long time that you could log out in an inn to automatically log out, so I would log out and hop on to another server to play a different character without waiting.
                        </div>
                    </div>
 
                </div>
			</section>

			<div className="flex flex-col px-10 mb-6">
				<figure className="max-w-sm">
                    <p>I don't have a lot of screen shots saved from the old days but here is one from my vendor house!</p>
                    <Link to="/images/uo-house-december-2004.jpg" reloadDocument={true}><img className="h-auto max-w-full rounded-lg" src="/images/uo-house-december-2004.jpg" alt="vendor house uo" /></Link>
                    <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">December 2004</figcaption>
				</figure>
			</div>

            <h2 className="text-3xl px-10 my-6 text-cyan-900 dark:text-cyan-200">Do you still play?</h2>
            <p className="my-4">I sure do! However, now I play Ultima Online on multiple servers - both retail and free shards.  My "main" server these days is UO Outlands but I'm always on the look out for a new UO Experience. I stream on YouTube and Twitch when I play and I also have some passion projects related to UO that you can check out.</p>
            <p className="my-8 text-center">
                 Check out the <Link to="/gaming/ultima-online/new-player-guides" className="underline">Ultima Online new player guides</Link> if you are interested in seeing how to get started with no help!
            </p>

			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4">
				{WatchCTA()}
			</div>
		</div>
	)
}


